import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { base64ToBlob, createBlobURL } from '../../../../../commonFunction';

const useStyles = makeStyles((theme) => ({
  cardWrap: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '13px 8px',
    borderBottom: '1px solid #F3F3F3',
    width: '100%',
  },
  cardName: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    marginLeft: 32,
    marginRight: 16,
    fontSize: '15px',
    fontWeight: 'bold',
    color: theme.palette.primaryColor,
    wordBreak: 'break-all',
    '& .MuiSvgIcon-root': {
      fontSize: 11,
      color: theme.palette.primaryColor,
      marginRight: 5,
    },
  },
  cardLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    justifyContent: 'right',
    marginRight: 16,
    marginLeft: 'auto',
    flexShrink: 0,
  },
  cardRegistrator: {
    fontSize: 13,
    justifyContent: 'right',
    flexShrink: 0,
  },
}));

function CustomerCardItemSp(props) {
  const {
    card,
    getCustomerCardImage,
  } = props;

  const classes = useStyles();

  // リンクをクリックしたときに画像取得→表示
  const onClick = async () => {
    const data = await getCustomerCardImage(card.cardId);
    if (data) {
      if (/^application\/pdf/.test(data.mimeType)) {
        window.open(createBlobURL(base64ToBlob(data.base64, data.mimeType)), '_blank');
      } else {
        const newTab = window.open('', '_blank');
        newTab.document.body.innerHTML = `<img src="${createBlobURL(base64ToBlob(data.base64, data.mimeType))}" alt="顧客カード" />`;
      }
    } else {
      const newTab = window.open('', '_blank');
      newTab.document.body.innerHTML = '<p>画像の取得に失敗しました。</p>';
    }
  };

  return (
    <Grid className={classes.cardWrap}>
      <Button
        variant="text"
        onClick={onClick}
        className={`${classes.cardName}`}
      >
        {card.fileName}
      </Button>
      <Typography className={`${classes.cardLabel}`}>
        登録者
      </Typography>
      <Typography className={`${classes.cardRegistrator}`}>
        {card.registrator}
      </Typography>
    </Grid>
  );
}

export default CustomerCardItemSp;
